let active = 0;
const queue = [];
const MAX_CONCURRENT = 3; // tune: 2–4 is ideal

export function scheduleAvatarLoad(task) {
    return new Promise((resolve, reject) => {
        queue.push(() => task().then(resolve).catch(reject));
        run();
    });
}

function run() {
    if (active >= MAX_CONCURRENT || queue.length === 0) return;

    active++;
    const job = queue.shift();

    job().finally(() => {
        active--;
        run();
    });
}
